import React from 'react';
import { Alert, Box, Card, CardContent, Typography } from '@mui/material';

import { useGetCurrentUserQuery } from '@/apis/extended/userApi';
import { useAuth } from '@/hooks/useAuth';

const AdminDebug: React.FC = () => {
  const { isLoading, isAuthenticated, isAdmin } = useAuth();
  const {
    data: user,
    error,
    isLoading: userLoading,
  } = useGetCurrentUserQuery();

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Admin Debug Information
      </Typography>

      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Authentication Status
          </Typography>
          <Typography>isLoading: {isLoading ? 'true' : 'false'}</Typography>
          <Typography>
            isAuthenticated: {isAuthenticated ? 'true' : 'false'}
          </Typography>
          <Typography>isAdmin: {isAdmin ? 'true' : 'false'}</Typography>
        </CardContent>
      </Card>

      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            User Data
          </Typography>
          <Typography>userLoading: {userLoading ? 'true' : 'false'}</Typography>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              Error: {JSON.stringify(error)}
            </Alert>
          )}
          {user && (
            <Box>
              <Typography>User ID: {user._id}</Typography>
              <Typography>Name: {user.name}</Typography>
              <Typography>Email: {user.email}</Typography>
              <Typography>Role: {user.role}</Typography>
              <Typography>Role Type: {typeof user.role}</Typography>
            </Box>
          )}
        </CardContent>
      </Card>

      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Expected Values
          </Typography>
          <Typography>Expected Admin Role: 'admin'</Typography>
          <Typography>
            Role Comparison: {user?.role === 'admin' ? 'MATCH' : 'NO MATCH'}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AdminDebug;
